import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { PageGetService } from '../../services';

export const fetchPageGet = createAsyncThunk(
    'pageGet/fetchPageGet',
    async ({ id }) => {
        const response = await PageGetService(id)
        return response.result
    }
);

const pageGetSlice = createSlice({
    name: 'pageGet',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchPageGet.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchPageGet.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchPageGet.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default pageGetSlice.reducer;
